import { createContext, useState, useContext } from 'react';
import { emptyFunction } from '../utils/functions';
import { StateSetter } from 'types/utils/React';

interface TourContextType {
  currentStep: number;
  isTourOpen: boolean;
  setCurrentStep: StateSetter<number>;
  setIsTourOpen: StateSetter<boolean>;
}

const initialState = {
  currentStep: 0,
  isTourOpen: true,
  setCurrentStep: emptyFunction,
  setIsTourOpen: emptyFunction,
};

export const TourContext = createContext<TourContextType>(initialState);

const { Provider } = TourContext;

interface TourProviderProps {
  children: React.ReactNode;
  initialIsTourOpen: boolean;
}

export const TourProvider = ({
  children,
  initialIsTourOpen,
}: TourProviderProps): JSX.Element => {
  const [currentStep, setCurrentStep] = useState(initialState.currentStep),
    [isTourOpen, setIsTourOpen] = useState(initialIsTourOpen);

  return (
    <Provider
      value={{ currentStep, isTourOpen, setCurrentStep, setIsTourOpen }}
    >
      {children}
    </Provider>
  );
};

export const useTourContext = () => useContext(TourContext);

export default useTourContext;